import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  Icon,
  Paper,
  Stack,
  TextField,
  InputAdornment,
  IconButton,
  Typography,
} from "@mui/material";
import * as React from "react";

export const Patentes = (props) => {
  const { poolMoviles, moviles, open, onClose, onSave } = props;
  const tbPatente = React.useRef();

  const [patente, setPatente] = React.useState("");
  const [success, setSuccess] = React.useState(0);
  const [verCheck, setVerCheck] = React.useState(false);

  React.useEffect(() => {
    setVerCheck(Boolean(patente) || patente !== "" || success === 2);
  }, [patente, success]);

  return (
    <Dialog open={open} fullWidth={true} maxWidth="sm">
      <DialogContent>
        <Stack direction="column" spacing={2}>
          <TextField
            label="Patente"
            inputRef={tbPatente}
            autoFocus
            color={
              success === 2 ? "success" : success === 1 ? "error" : "inherits"
            }
            value={patente}
            onChange={(e) => {
              setSuccess(false);
              setPatente(e.target.value.toUpperCase());
            }}
            focused
            slotProps={{
              input: {
                endAdornment: (
                  <InputAdornment position="end">
                    {success === 2 && <Icon fontSize="small">check</Icon>}
                    {success === 2 && (
                      <IconButton
                        edge="end"
                        aria-label="Agregar patente"
                        onClick={() => {
                          onSave({
                            baja: 0,
                            movil:
                              (poolMoviles &&
                                poolMoviles.find(
                                  (m) => m.patente === patente,
                                )) ||
                              null,
                          });

                          setSuccess(false);
                          setPatente("");
                          tbPatente.current.focus();
                        }}
                      >
                        <Icon color="primary">add</Icon>
                      </IconButton>
                    )}
                    {verCheck && success < 2 && (
                      <IconButton
                        edge="end"
                        aria-label="Verificar"
                        color="success"
                        onClick={() => {
                          const esta =
                            poolMoviles &&
                            poolMoviles.findIndex(
                              (m) => m.patente === patente,
                            ) > -1;
                          setSuccess(esta ? 2 : 1);
                          tbPatente.current.focus();
                        }}
                      >
                        <Icon color="success">check</Icon>
                      </IconButton>
                    )}
                  </InputAdornment>
                ),
              },
            }}
          />
          <Paper variant="outlined">
            <Stack sx={{ height: "200px", p: 2 }}>
              {moviles &&
                moviles
                  .filter((mf) =>
                    mf.patente.toUpperCase().includes(patente.toUpperCase()),
                  )
                  .map((m, index) => (
                    <Stack direction="row" key={"aaa" + index}>
                      <Typography fontWeight="bold" sx={{ flexGrow: 1 }}>
                        {m.patente}
                      </Typography>
                      <IconButton
                        onClick={() =>
                          onSave({
                            baja: 1,
                            movil:
                              (poolMoviles &&
                                poolMoviles.find(
                                  (m1) => m1.patente === m.patente,
                                )) ||
                              null,
                          })
                        }
                      >
                        <Icon fontSize="small">delete</Icon>
                      </IconButton>
                    </Stack>
                  ))}
            </Stack>
          </Paper>
        </Stack>
      </DialogContent>
      <DialogActions sx={{ p: 0, pr: 1 }}>
        <Button onClick={onClose}>Cerrar</Button>
      </DialogActions>
    </Dialog>
  );
};
export default Patentes;
